<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'sws_air_simulation' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="ion-padding">

  <ion-card class="config-card" (click)="openLifetime()">
    <div class="config-icon">
      <img [src]="mappedWindowType?.img" [alt]="projectData?.windowtype?.name | translate"
        *ngIf="mappedWindowType?.img" />
    </div>
    <ion-card-header>
      <ion-card-title class="config-title">{{ 'lifetime' | translate }}</ion-card-title>
      <button class="edit-button">
        <ion-icon src="assets/icons/edit-icon.svg"></ion-icon>
        <span class="edit-text">{{ 'edit' | translate }}</span>
      </button>
    </ion-card-header>

    <!-- Card Content -->
    <ion-card-content>
      <div class="config-details">
        <p>{{ 'installation_place' | translate }} : <strong> {{ lifetimeData.installationPlace }} </strong></p>
        <p>{{'latitude' | translate}} : <strong> {{lifetimeData.latitude}} </strong></p>
        <p>{{'longitude' | translate}} : <strong> {{lifetimeData.longitude}} </strong></p>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card class="config-card" (click)="openElevatedTransport()">
    <div class="config-icon">
      <img [src]="mappedWindowType?.img" [alt]="projectData?.windowtype?.name | translate"
        *ngIf="mappedWindowType?.img" />
    </div>

    <ion-card-header>
      <ion-card-title class="config-title">{{ 'elevated_transport' | translate }}</ion-card-title>
      <button class="edit-button">
        <ion-icon src="assets/icons/edit-icon.svg"></ion-icon>
        <span class="edit-text">{{ 'edit' | translate }}</span>
      </button>
    </ion-card-header>

    <!-- Card Content -->
    <ion-card-content>
      <div class="config-details">
        <p>{{'transport' | translate}} : <strong> {{elevatedTransportData.transportKey | translate}}</strong></p>
        <p>{{'max_height_diff' | translate}} : <strong> {{ elevatedTransportData.maxHeightDiff ?? '-' }} {{ elevatedTransportData.maxHeightDiff !== null ? ' m' : '' }} </strong></p>
      </div>
    </ion-card-content>
  </ion-card>

  <div class="form-container">
    <div class="select-group">
      <ion-label class="input-label">{{'GLASS_SHORT_EDGE' | translate}} (mm)</ion-label>
      <ion-input class="bordered-input" type="number" inputmode="decimal" [(ngModel)]="shortEdge" name="shortEdge"
        min="0" max="5" step="0.01" (ionInput)="onShortEdgeChange()">
      </ion-input>
    </div>
    <div class="select-group">
      <ion-label class="input-label">{{'GLASS_LONG_EDGE' | translate}} (mm)</ion-label>
      <ion-input class="bordered-input" type="number" inputmode="decimal" [(ngModel)]="longEdge" name="longEdge" min="0"
        max="5" step="0.01" (ionInput)="onLongEdgeChange()">
      </ion-input>
    </div>
  </div>
  <ion-chip color="primary" class="customChip primaryClass">
    <ion-label>
      <div class="chip-content">
        <div class="chip-title">{{'results' | translate}}</div>
        <div class="chip-description">
          <ul>
            <li *ngIf="isLoading">Calculating...</li>
            <ng-container *ngIf="!isLoading && !hasError">
              <li>{{'lifetime' | translate }}: {{ lifetimeResult | translate }}</li>
              <li>{{ 'elevated_transport' | translate }}: {{ transportResult | translate}}</li>
            </ng-container>
            <li *ngIf="hasError" style="color: red;">{{ errorMessage }}</li>
          </ul>
        </div>
      </div>
    </ion-label>
  </ion-chip>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button class="next-btn" (click)="next()" expand="block" [disabled]="isValidateDisabled">
      {{'validate' | translate}}
    </ion-button>
  </div>
</ion-footer>